//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { ConnectPanelActions } from '@catalog-ingestion/actions/connectPanelActions';
import { GoogleCatalogIngestionModalActions } from '@catalog-ingestion/actions/googleCatalogIngestionModalActions';
import { ValidationErrorLayout } from '@catalog-ingestion/components/validation-panel/ValidationErrorLayout';
import { useBoundActionCreators } from '@hooks/useCuralateStore';

export const EmptyProductCatalogError: React.FunctionComponent = () => {
  const {
    resetGoogleCatalogIngestionState,
    openGoogleCatalogIngestionModal
  } = useBoundActionCreators(GoogleCatalogIngestionModalActions);

  const {toggleIsValidating} = useBoundActionCreators(ConnectPanelActions);

  const onRetry = () => {
    toggleIsValidating();
    resetGoogleCatalogIngestionState();
    openGoogleCatalogIngestionModal();
  };

  return (
    <PanelContainer>
      <ValidationErrorLayout
        errorMessage='Nuts! The uploaded product catalog is empty.'
        errorDescription='Please check your catalog for errors and try again'
        buttonText='Retry Catalog Connection'
        onButtonClick={ onRetry }
      />
    </PanelContainer>
  );
};

const PanelContainer = styled.div`
  padding-top: ${({theme}) => theme.spacings['5']};
  display: flex;
  justify-content: center;
`;

export default EmptyProductCatalogError;
